/**
 * Roles for dimensions.  Prefer using these over hard coding.  It makes it easier
 * to change things.
 *
 * The only roles we need to place in here are the ones that span through the app.
 *
 * If you have a specific use-case, like a spinner color.  It makes more sense to
 * put that in the <Spinner /> component.
 */
export const dimensions = {
  buttonRadius: 10,
  chatWidth: 255,
  checkBoxRoundSize: 24,
  calendarListItemSeparation: 6,
}
